import React from "react";
import {
  FlexRowBetween,
  MediumFont,
  PopupForm,
  TextWithPic,
} from "../../common/Style";
import { useHistory } from "react-router-dom";

import ClientRoutes from "../../../navigation/Routes";

const Gifts = ({ sP, uPphone }) => {
  let history = useHistory();

  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <div>
          אתר מתנות באשראי הינו אתר חיצוני לאתר זה, לחיצה על הכתובת הבאה תפתח את
          האתר, במידה ונכנסתם בעבר בטח תהיו מחוברים אוטומטית, במידה ולא אזי מספר
          הטלפון של משתמש המערכת קיבל את הסיסמא בהודעת sms תחת שולח בשם ibs, יש
          לעשות חיפוש ולמצוא את ההודעה
        </div>
        <FlexRowBetween style={{ marginTop: "15px" }}>
          <a
            onClick={(e) => e.stopPropagation()}
            style={{
              textDecoration: "none",
              color: "#3a3c3f",
            }}
            target="_blank"
            rel="noreferrer"
            href={`https://i-b-s.site/`}
          >
            <TextWithPic style={{ width: "max-content" }}>
              מעבר לאתר
            </TextWithPic>
          </a>
        </FlexRowBetween>
      </div>
    </PopupForm>
  );
};

export default Gifts;
